export default "public/arrow-left.svg";